import type { RoleConfig } from '../types.js';

export const mayor: RoleConfig = {
  id: 'mayor',
  faction: 'town',
  title: { ru: 'Мэр', uk: 'Мер' },
  latin: 'MAYOR',
  number: '12',
  accent: '#f3c84a',
  ability: {
    ru: 'Может один раз за игру публично выйти днём — после этого его голос считается за два. Пока скрыт — голосует как обычно.',
    uk: 'Може один раз за гру публічно вийти вдень — після цього його голос рахується як два. Поки прихований — голосує як зазвичай.',
  },
  abilities: [
    { key: 'reveal', phase: 'day', cadence: 'one-time', shape: 'targetless', targetless: true, charges: 1 },
  ],
  voteWeight: 2,
  victory: { type: 'town' },
};
